import { useState, useEffect } from 'react';

export default function Countdown({ targetDate, city, compact = false }) {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 60000); // Update every minute
    return () => clearInterval(timer);
  }, []);

  if (!targetDate) return null;

  const target = new Date(targetDate + 'T00:00:00');
  const diff = target - now;
  if (diff <= 0) return null;

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const weeks = Math.floor(days / 7);
  const remainingDays = days % 7;
  const months = Math.floor(days / 30);

  if (compact) {
    return (
      <div className="flex items-center gap-2 text-xs">
        <span className="text-teal font-bold">{days} days</span>
        <span className="text-brand-ink/55">until {city || 'your trip'}</span>
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-r from-teal/10 via-navy-light to-teal/10 rounded-2xl border border-teal/20 p-5">
      <div className="text-center">
        <div className="text-xs text-teal/60 uppercase font-bold tracking-widest mb-3">
          Countdown to {city || 'your trip'}
        </div>
        <div className="flex items-center justify-center gap-4">
          <CountdownUnit value={months} label="months" />
          <div className="text-2xl text-brand-ink/40">:</div>
          <CountdownUnit value={weeks} label="weeks" />
          <div className="text-2xl text-brand-ink/40">:</div>
          <CountdownUnit value={remainingDays} label="days" />
          <div className="text-2xl text-brand-ink/40">:</div>
          <CountdownUnit value={hours} label="hours" />
        </div>
        <div className="text-brand-ink/55 text-xs mt-3">
          {days} days total
        </div>
      </div>
    </div>
  );
}

function CountdownUnit({ value, label }) {
  return (
    <div className="text-center">
      <div className="text-3xl sm:text-4xl font-black text-white tabular-nums">{value}</div>
      <div className="text-[10px] text-brand-ink/55 uppercase tracking-wider">{label}</div>
    </div>
  );
}
